{
  "资料批量导入": "Bulk imports",
  "企业与供需信息批量导入": "Import companies and listings",
  "选择资料": "Select data",
  "预检与去重": "Precheck and deduplicate",
  "确认提交": "Confirm import",
  "下载企业 XLSX 模板": "Company XLSX template",
  "下载供需 XLSX 模板": "Listing XLSX template",
  "每批最多 1000 行、10 MiB。目标国家以逗号或顿号分隔；国家和行业可填写名称或编码。": "Up to 1,000 rows and 10 MiB per batch. Separate countries with commas. Countries and industries accept names or codes.",
  "企业导入仅创建档案，不开通账号、认证或会员。供需须具备对应企业认证和授权，导入后进入待审核。": "Company imports create profiles without accounts, verification or membership. Listings require the relevant company verification and authorization and enter review after import.",
  "本批导入类型": "Import type",
  "企业基础资料": "Company profiles",
  "采购需求／供应信息": "Purchase requests / supply offers",
  "数据来源及授权核验说明": "Data source and authorization verification",
  "导入文件": "Import file",
  "执行预检": "Run precheck",
  "请选择 XLSX 文件": "Select an XLSX file",
  "请选择不超过 10 MiB 的 XLSX 文件": "Select an XLSX file no larger than 10 MiB",
  "部分行未通过预检，请查看错误原因": "Some rows failed precheck. Review the errors.",
  "共 {{total}} 行，有效 {{valid}} 行，异常 {{failed}} 行": "{{total}} rows: {{valid}} valid, {{failed}} invalid",
  "确认导入有效行": "Import valid rows",
  "已提交": "Submitted",
  "已预检": "Prechecked",
  "导入批次及操作记录": "Import history",
  "预检时间": "Prechecked at",
  "导入批次详情": "Import batch details",
  "下载错误行原因": "Download row errors",
  "选择文件": "Choose file",
  "异常": "Invalid",
  "企业资料": "Company profiles",
  "供需信息": "Listings",
  "导入批次查看": "View import batches",
  "企业与供需批量导入": "Import companies and listings"
}
